import e from"react-contenteditable";import n from"styled-components";const o=n(e)`
	white-space: pre-wrap;

	${({isEditing:e,numberOfRows:n=3})=>!e&&`\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: ${n};\n        overflow: hidden;\n    `}

	&:focus {
		outline: none;
	}
`;export{o as EditableContentContainer};
